import { useUserStore } from '../store/modules/user';
import {getIam, request} from '../utils/request';

// eslint-disable-next-line camelcase
// export const c = '/' +userStore['ctx'] + '/brief';

// 所有表结构
export function getIamBriefList() {
  const iam = getIam();
  //const userStore = useUserStore();
  return request.post({
    url: `${iam}brief_info`,
    // data: { tables: true, details: [] }
    data: {}
  });
}

// 所有表结构
// 这里不能根据版本进行查看，因为用户修改字典之后字典的ver就会发生变化
// 如果根据ver来进行查询，很有可能查询失败，这样就会导致使用前端字典的选择框等组件内容为空,只有清理缓存才能恢复
// 所以这里不根据ver来进行查询，而是直接进行查询
export async function getBriefList(ver:any) {
  const userStore = useUserStore();
  let p = ver?`?ver=${ver}`:``;
  return request.post({
    // url: `/${userStore['ctxt']}/brief${p}`,
    url: `/${userStore['ctxt']}/brief`,
    data: {}
  });
}

// 添加字段
export function addBriefTablFields(par) {
  const userStore = useUserStore();
  return request.post({
    url: `/${userStore['ctxt']}/attr/add`,
    data: par
  });
}
// 编辑字段
export function editBriefTablFields(par) {
  const userStore = useUserStore();
  return request.post({
    url: `/${ userStore['ctxt']  }/attr/mod`,
    data: par
  });
}
// 删除字段
export function deleteBriefTablFields(par) {
  const userStore = useUserStore();
  return request.post({
    url: `/${ userStore['ctxt']  }/attr/rmv`,
    data: par
  });
}
// 表字段情况
export function getTabFields(tid) {
  const userStore = useUserStore();
  return request.post({
    url: `/${ userStore['ctxt']  }/fields?tbl=${tid}`,
    data: {}
  });
}
